import { createAction } from '@reduxjs/toolkit';

const loadTextReader = createAction('TEXT_READER_LOAD');
const setLanguage = createAction<string>('TEXT_READER_SET_LANGUAGE');

export default {
  loadTextReader,
  setLanguage
};
